import { render, staticRenderFns } from "./quotation-history.vue?vue&type=template&id=224b91c1&scoped=true"
import script from "./quotation-history.vue?vue&type=script&lang=js"
export * from "./quotation-history.vue?vue&type=script&lang=js"
import style0 from "./quotation-history.vue?vue&type=style&index=0&id=224b91c1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224b91c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('224b91c1')) {
      api.createRecord('224b91c1', component.options)
    } else {
      api.reload('224b91c1', component.options)
    }
    module.hot.accept("./quotation-history.vue?vue&type=template&id=224b91c1&scoped=true", function () {
      api.rerender('224b91c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/quotation-apply/quotation-history.vue"
export default component.exports